import React from "react";

const StepsCard = ({ steps, activeNumber, disableShadow, className = "" }) => {
    const renderSteps = () => {
        return (
            steps &&
            steps.map((step, index) => {
                return (
                    <div key={index} className="steps-items">
                        <div
                            className={`steps-number step-number-one ${
                                activeNumber === index + 1 ? "active" : ""
                            } ${activeNumber > index + 1 ? "finished" : ""}`}
                        >
                            {step.number}
                        </div>
                        <div className="steps-title">{step.name}</div>
                    </div>
                );
            })
        );
    };
    return (
        <>
            <div
                className={`card-table ${
                    disableShadow ? "" : "shadow"
                } ${className}`}
            >
                <div className="steps-wrapper">{renderSteps()}</div>
            </div>
        </>
    );
};

export default StepsCard;
